import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import DashboardLayout from '@/components/layouts/DashboardLayout';

// Lazy load all app pages
const DashboardPage = lazy(() => import('@/pages/Dashboard'));
const GroupsPage = lazy(() => import('@/pages/Groups'));
const ContactsPage = lazy(() => import('@/pages/Contacts'));
const MediaPage = lazy(() => import('@/pages/Media'));
const InboxPage = lazy(() => import('@/pages/Inbox'));
// const AutomationPage = lazy(() => import('@/pages/Automation'));
// const ExtractPage = lazy(() => import('@/pages/Extract'));
// const IntegrationsPage = lazy(() => import('@/pages/Integrations'));
const SettingsPage = lazy(() => import('@/pages/Settings'));
const TagsPage = lazy(() => import('@/pages/Tags'));
const TagDetailsPage = lazy(() => import('@/pages/Tags/Details'));
const TagCreatePage = lazy(() => import('@/pages/Tags/Create'));
const TagEditPage = lazy(() => import('@/pages/Tags/Edit'));

// New pages
const CommunitiesPage = lazy(() => import('@/pages/Communities'));
// const AuditTrialPage = lazy(() => import('@/pages/AuditTrial'));
// const SlaTrackerPage = lazy(() => import('@/pages/SlaTracker'));
// const IssuesPage = lazy(() => import('@/pages/Issues'));
const TicketsPage = lazy(() => import('@/pages/Tickets'));

// Management pages
const ManagementDashboard = lazy(() => import('@/pages/Management/Dashboard'));
const WahaSessionPage = lazy(() => import('@/pages/WahaSession'));
const GroupManagementPage = lazy(() => import('@/pages/GroupManagement'));
const TeamMembersPage = lazy(() => import('@/pages/TeamMembers'));
const InvitationsPage = lazy(() => import('@/pages/Invitations'));

const PageLoader = () => (
  <div className="flex h-screen items-center justify-center overflow-hidden">
    <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-gray-900"></div>
  </div>
);

export const AppRoutes = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="/inbox" element={<InboxPage />} />
          {/* <Route path="/automation" element={<AutomationPage />} />
          <Route path="/extract" element={<ExtractPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} /> */}
          <Route path="/settings" element={<SettingsPage />} />

          {/* Management Routes */}
          <Route path="/management" element={<ManagementDashboard />} />
          <Route
            path="/management/waha-session"
            element={<WahaSessionPage />}
          />
          <Route path="/management/groups" element={<GroupManagementPage />} />
          <Route
            path="/management/team-members"
            element={<TeamMembersPage />}
          />
          <Route path="/management/invitations" element={<InvitationsPage />} />

          {/* New Pages */}
          <Route path="/communities" element={<CommunitiesPage />} />
          {/* <Route path="/audit-trial" element={<AuditTrialPage />} />
          <Route path="/sla-tracker" element={<SlaTrackerPage />} />
          <Route path="/issues" element={<IssuesPage />} /> */}
          <Route path="/tickets" element={<TicketsPage />} />

          {/* Tags Routes */}
          <Route path="/tags" element={<TagsPage />} />
          <Route path="/tags/:id" element={<TagDetailsPage />} />
          <Route path="/tags/create" element={<TagCreatePage />} />
          <Route path="/tags/:id/edit" element={<TagEditPage />} />

          {/* Default redirect to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Route>

        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
};
